/* eslint @typescript-eslint/no-explicit-any: 0 */

import Serializer from "./Serializer";
import { Tag } from "../../../app/types/Tag";

class TagSerializer extends Serializer<Tag> {
    public serialize(tag: Partial<Tag>) {
        return {
            name: tag.label,
            description: tag.description,
        };
    }

    public deserialize(data: any): Tag {
        return {
            id: data.id,
            label: data.name,
            description: data.description,
            count: data.count,
        };
    }
}

export default TagSerializer;
